// Quick add popup: option pills pick the variant, quantity stepper.
// Popup open/close and add to cart come from quick-add.js and product-form.js.
if (!customElements.get('scruffi-qv-picker')) {
  customElements.define(
    'scruffi-qv-picker',
    class ScruffiQvPicker extends HTMLElement {
      connectedCallback() {
        this.variants = JSON.parse(this.querySelector('script[type="application/json"]').textContent);
        this.idInput = this.querySelector('input[name="id"]');
        this.qtyInput = this.querySelector('input[name="quantity"]');
        this.addButton = this.querySelector('.scruffi-qv__add');

        this.addEventListener('change', (event) => {
          if (event.target.classList.contains('scruffi-qv__opt-input')) this.onOptionChange();
        });
        // Bubbling change event lets the offer strip react to the stepper
        this.querySelectorAll('.scruffi-qv__step').forEach((button) =>
          button.addEventListener('click', () => {
            const next = (parseInt(this.qtyInput.value, 10) || 1) + Number(button.dataset.step);
            this.qtyInput.value = Math.max(1, next);
            this.qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
          })
        );
      }

      formatMoney(cents) {
        // ponytail: handles {{amount}} formats only (store uses $ / SGD); extend if the format changes
        return this.dataset.moneyFormat.replace(/\{\{\s*amount\s*\}\}/, (cents / 100).toFixed(2));
      }

      onOptionChange() {
        const selected = Array.from(this.querySelectorAll('.scruffi-qv__option'), (fieldset) =>
          fieldset.querySelector('input:checked')?.value
        );
        const variant = this.variants.find((v) => v.options.every((value, i) => value === selected[i]));
        const label = this.addButton.querySelector('span');

        if (!variant) {
          this.addButton.disabled = true;
          label.textContent = 'Unavailable';
          return;
        }

        this.idInput.value = variant.id;
        this.querySelector('.scruffi-qv__price').textContent = this.formatMoney(variant.price);
        const compare = this.querySelector('.scruffi-qv__compare');
        compare.hidden = !(variant.compare_at_price > variant.price);
        if (!compare.hidden) compare.textContent = this.formatMoney(variant.compare_at_price);

        this.addButton.disabled = !variant.available;
        label.textContent = variant.available ? 'Add to Cart' : window.variantStrings.soldOut;

        const thumb = this.closest('product-info')?.querySelector('.scruffi-qv__thumb');
        if (thumb && variant.featured_image) {
          thumb.srcset = '';
          thumb.src = `${variant.featured_image.src}${variant.featured_image.src.includes('?') ? '&' : '?'}width=240`;
        }
      }
    }
  );
}
